import { OverlayTrigger, Tooltip as BootstrapTooltip } from "react-bootstrap"
import cx from 'classnames';
import styles from './tooltip.module.scss';

 const Tooltip = ({placement, className, content, children, disabled, container=document.body}) => {
  
  if(disabled) {
    return children;
  }

  return (
    <OverlayTrigger
      container={container}
      placement={placement}
      popperConfig={{
        modifiers: [
          {
            name: 'flip',
            enabled: true,
          },
          {
            name: 'preventOverflow',
            options: {
              boundary: 'viewport',
            },
          },
        ],
      }}
      trigger={['hover', 'focus']}
      overlay={
        <BootstrapTooltip className={cx(styles.tooltip, className)} placement={placement}>
          {content}
        </BootstrapTooltip>
      }
    >
      {children}
    </OverlayTrigger>
  );
}

export default Tooltip;